import {
  getPageAllowedRoles,
  userHasCorrectRole,
} from "../../config/roles";

// Splits the local part of an email into name segments, e.g. "adam.smith" -> ["adam", "smith"].
function getNameSegments(userDetails) {
  if (!userDetails) {
    return [];
  }

  const localPart = userDetails.split("@")[0];
  return localPart.split(/[._-]/).filter(Boolean);
}

// Best-effort initials, e.g. "adam.smith@x" -> "AS".
function getInitials(userDetails) {
  const segments = getNameSegments(userDetails);

  if (segments.length >= 2) {
    return (segments[0][0] + segments[1][0]).toUpperCase();
  }

  if (segments.length === 1) {
    return segments[0].slice(0, 2).toUpperCase();
  }

  return "";
}

// Best-effort display name, e.g. "adam.smith@x" -> "Adam Smith".
function getDisplayName(userDetails) {
  const segments = getNameSegments(userDetails);

  if (segments.length === 0) {
    return "";
  }

  return segments
    .map((segment) => segment[0].toUpperCase() + segment.slice(1))
    .join(" ");
}

// Maps GlobalContext state to Header's plain props, keeping Header context-free.
function getHeaderProps(globalState) {
  const { slot, user, version } = globalState;

  const searchAllowedRoles = getPageAllowedRoles("search");
  const settingsAllowedRoles = getPageAllowedRoles("settings");
  const userDetails = user && user.userDetails;

  return {
    signedIn: Boolean(user),
    slot,
    version,
    userDetails,
    userInitials: getInitials(userDetails),
    userName: getDisplayName(userDetails),
    showSearch: userHasCorrectRole(user, searchAllowedRoles),
    showSettings: userHasCorrectRole(user, settingsAllowedRoles),
  };
}

export { getHeaderProps, getInitials, getDisplayName };
